export const calculatePercentage = (bytesSent: number, totalSize: number) => {
  if (totalSize === 0) {
    return 0;
  }

  return parseInt(`${(bytesSent / totalSize) * 100}`);
};
